import React from "react";

const Footer = () => {
    return (
        <footer className="footer bg-dark text-white py-5">
            <div className="container">
                <div className="row">
                    {/* Columna del mapa */}
                    <div className="col-md-6 mb-4 mb-md-0">
                        <h5 className="text-uppercase" data-aos="fade-down" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">Encuéntranos</h5>
                        <div className="map-container" data-aos="zoom-in" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3277.4341097727274!2d-58.40919769999999!3d-34.7698453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcd2f17dceb1e3%3A0xfea9080946dc286f!2sSim%C3%B3n%20Bol%C3%ADvar%20857%2C%20B1832%20Lomas%20de%20Zamora%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1736188282431!5m2!1ses!2sar"
                                width="100%"
                                height="300"
                                style={{ border: 0, borderRadius: "8px" }}
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Mapa de Google"></iframe>
                        </div>
                    </div>

                    {/* Columna del contacto */}
                    <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
                        <h5 className="text-uppercase mb-3" data-aos="fade-down" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">Síguenos en instagram</h5>
                        <a
                            data-aos="zoom-in" data-aos-offset="0" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
                            href="https://www.instagram.com/miminaresidencia/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="instagram-icon"
                        >
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>
                </div>
                {/* Separador */}
                <hr className="my-4" style={{ borderColor: "white" }} />

                {/* Pie del footer */}
                <div className="text-center" data-aos="fade-down" data-aos-offset="0" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                    <p className="mb-0">© 2025 Mimina - Todos los derechos reservados</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;